import React from 'react';

import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {TableCell} from "../../../core/components/table/table-cell";
import {ScoreboardWidgetCompetitorViewModel} from "../models/scoreboard-widget.competitor-view-model";
import {Image, ImageProps} from "../../../core/components/image/image";
import {Link} from "../../../core/components/link/link";
import {LinkProps} from "../../../core/components/link/link-composer";

export class ScoreboardWidgetCompetitorCellProps extends BaseProps {
  competitor: ScoreboardWidgetCompetitorViewModel;
}

export const ScoreboardWidgetCompetitorCell = ({competitor}: ScoreboardWidgetCompetitorCellProps) => {
  const imageProps: ImageProps = {
    src: competitor.possessionLogoParams,
    width: 12,
    height: 12,
    className: 'scoreboard-widget-competitor-possession-logo'
  }

  const linkProps: LinkProps = {
    model: competitor.linkModel,
    className: [(competitor.isWinner ? 'scoreboard-widget-competitor-winner' : ''), 'scoreboard-widget-competitor-cell-link'].join(' ')
  }


  return (
    <TableCell className={'scoreboard-widget-competitor-cell'}>
      <Link {...linkProps}>
        {
          competitor.name
        }
      </Link>
      {
        competitor.inPossession && <Image {...imageProps}/>
      }
    </TableCell>
  )
};
